import httpClient from "../../../shared/api/httpClient";

function unpack(res) {
  if (res && typeof res === "object" && "data" in res) return res.data;
  return res;
}

function asArray(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.data)) return data.data;
  return [];
}

export async function getUserAccessStatus() {
  const res = await httpClient.get("/admin/users/access-status");
  return asArray(unpack(res));
}

export async function updateUserAccessStatus(userId, isActive) {
  const res = await httpClient.patch(`/admin/users/${userId}/access-status`, {
    isActive: Boolean(isActive),
  });

  return unpack(res);
}